import { TOGGLE_FILTER } from '../actions/index';

export default ( state = {}, action ) => {
	switch ( action.type ) {
		case TOGGLE_FILTER:
			let currentState = state;
			currentState[ action.payload.page ] = action.payload.toggle;
			let newState = Object.assign( {}, currentState );
			return newState;
	}
	return state;
}